<template>
    <div class="Offers">
        <menuBox :step="5"></menuBox>
        <div class="banner">
            隐私政策
        </div>
        <div class="privacy-box">
            <div class="privacy">
               <br> 请仔细阅读本政策。访问本网站即表示您认可并同意本政策中所述的做法，需要您特定许可的地方除外。本隐私政策以及本网站上可能不时更新的法律声明描述了我们如何收集、使用和披露通过本网站或在我们业务活动过程中收集的个人和非个人信息。
               <br> 根据适用的数据保护法，我们将负责控制本网站上从您处收集的个人信息，或者与您一起开展或发展我们的业务。
               <br> <br> <strong>我们自动收集的信息</strong>                
               <br> 当您访问本网站时，我们的服务器会自动收集某些浏览器或设备生成的信息，包括但不限于：
               <br> ·域名； 
               <br> ·IP地址；
               <br> ·您访问的日期、时间和持续时间；
               <br> ·浏览器类型；
               <br> ·操作系统；
               <br> ·页面访问情况。
               <br> 我们不会使用此自动收集的信息来尝试识别您的身份，但我们可能会将其与您自愿提供的信息相关联，详见下文。
               <br> <br> <strong>您提供的信息</strong>                
               <br> 在使用本网站与我们开展业务或寻求与我们开展业务时，您可以通过以下方式自愿向我们提供个人信息：
               <br> ·通过在我们的网站上或在广告宣传着陆页上或在任何其他我们开展业务的地方填写表格（如“联系我们”表格）；
               <br> ·通过订阅电子报或其他信息；
               <br> ·通过电话、电子邮件或我们的其他联系方式与我们联系；
               <br> ·或通过申请工作、工作安排或实习。 
               <br> 通常，您提供给我们的个人信息可能包括姓名、公司名称、地址、电子邮件地址、电话号码以及任何其他用以解决疑问或投诉的个人信息。与您签订合同时将需要这些信息（例如服务合同或购买协议或提供诸如从我们网站下载信息等服务）。如果没有提供这些信息，则可能导致我们无法为您提供所需的服务或产品申请。 
               <br> <br> <strong>个人信息的使用</strong>

               <br> 以下概述了我们使用您个人信息的目的。请注意，有关我们如何处理您个人信息的其他详细信息可能会通过单独的通知或合同提供给您。 
               <br>  所有您个人信息的处理过程（即使用）都符合处理“条件”。在大多数情况下，合法处理的依据是： 
               <br> ·您已经同意处理；
               <br> ·与您签订合同或签订合同的步骤需要进行处理；
               <br> ·依据相关法律我们必须进行处理；或
               <br> ·在不会触犯您利益和基本权利的前提下，基于我们的合法权益，特别是我们使用供应商、客户和网站用户数据与他们以及他人开展和发展我们业务活动的合法权益进行处理。 
               <br> 我们使用我们收集的个人信息来：
               <br> ·与您和他人一起开展和发展我们的业务；
               <br> ·改进我们的网站，以及我们的产品和服务；
               <br> ·根据用户需求定制我们的网站；
               <br> ·为您提供您所要求的文件或信息；
               <br> ·与用户交流以解决他们的疑问或投诉；
               <br> ·为您提供您所要求的任何服务或产品；
               <br> 如果允许，向您发送营销信息。 
               <br>  
               <br><br> <strong>营销、短信和电子邮件</strong> 
               <br> 在合法且事先征得您同意的前提下，我们可能会通过短信和电子邮件与您联系，向您介绍我们的产品和服务。如果您想退订此类营销信息，请使用我们在电子邮件中提供的“取消订阅”链接，或通过网站中标注的联系方式直接与我们联系，我们将停止向您发送此类信息。
               <br> 为营销目的进行分析
               <br> 分析的目的是为了向您提供与贵公司具有高度相关性或适用性的网站内容或电子邮件内容。为此，我们使用您以及数据增强服务第三方提供的信息，尝试和识别贵公司的SIC行业代码和其他重要信息。此外，我们还会根据您在我们网站上的访问模式（我们自动收集的信息）以及对我们的电子邮件（您提供的信息）的回复，尝试并确定贵公司可能感兴趣的产品和应用。根据这些信息，我们将调整电子邮件内容和潜在的网站内容，以更好地匹配贵公司的要求和兴趣。所述的处理过程以我们的合法利益为基础。
               <br><br> <strong>安全</strong> 
               <br> 我们使用数据存储和安全技术来保护您的个人信息免遭未经授权的访问、滥用或泄露、未经授权的修改或非法破坏或意外丢失。但请注意，没有任何网站能够确保100％安全，我们不对超出我们控制范围的未经授权或意外访问承担负责。
               <br><br> <strong>保留您的信息</strong> 
               <br> 我们实施保留个人信息的一般规则，在达到收集数据的目的之后，我们不会继续保留个人信息。但在某些情况下（如根据法律、税务和会计要求），我们可能会对个人信息保留更长时间。
               <br> 在特定情况下，我们也可能会对您的个人信息保留更长的时间，以便在发生投诉或出现问题时我们有您与我们交易的准确记录。
               <br><br> <strong>您的权利</strong> 
               <br> 根据适用法律，您可能拥有以下部分或全部涉及您个人信息的权利：
               <br> ·获取您个人信息的副本，以及有关如何以及以什么为基础处理个人信息的信息；
               <br> ·纠正不准确的个人信息（包括完成不完整个人信息的权利）； 
               <br> ·删除您的个人信息（在就其收集或处理目的而言不再需要的有限情况下）； 
               <br> ·在以下情况下限制处理您的个人信息： 
               <br> ·个人信息的准确性受到质疑；
               <br> ·处理不合法，但您反对删除个人信息；
               <br> ·我们不再需要个人信息，但仍需要它来提出、行使或辩护法律索赔；
               <br> ·当我们在征得您同意的前提下或为履行与您签订的合同合法处理您的数据时，将数据以机器可读的格式存入第三方（或您处）；
               <br> ·撤销您对我们处理您个人信息的同意（在处理需要征得您同意的情况下）；
               <br> ·反对仅基于自动处理或分析的决策；
               <br> ·获取或查看针对将您的个人信息转移给第三国或国际组织所采取的适当保护措施的副本。
               <br> 除上述权利外，您有权反对我们基于合法利益对您的信息进行处理，包括（与您的同意相背，或为了与您签订合同）进行分析。您也有权反对我们为实现直接营销目的对您的信息进行处理，包括针对营销目的进行分析。 

               <br> 您也有权向当地监管机构提出有关保护数据的投诉。 
               <br> 关于所有这些权利，请使用页面上部的“联系我们”链接联系我们。请注意，我们可能会要求提供身份证明，我们保留在法律允许的情况下收取费用的权利，例如，如果您的请求明显毫无依据或您提出过度要求。我们将尽力在所有适用的时间范围内回应您的请求。 
               <br><br> <strong>联系信息</strong> 
               <br> 如果您对本政策有任何疑问或者您想行使您的任何权利，请点击此处提交您的请求。

            </div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.banner{
    width: 100%;
    height: 480px;
    background: url(../assets/banner-3.png);
    background-size: 100% 100%;
    font-size: 40px;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}
.privacy-box{
    padding: 119px 390px;
    overflow: hidden;
    .privacy{
        // width: 1140px;
        height: 746px;
        background: #F3F5F6;
        border-radius: 8px;
        padding: 37px 40px;
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        overflow-y: scroll;
        strong{
            color: #333;
        }
    }
}
</style>